import { render, staticRenderFns } from "./Research.vue?vue&type=template&id=37c0daa1&scoped=true&"
import script from "./Research.vue?vue&type=script&lang=ts&"
export * from "./Research.vue?vue&type=script&lang=ts&"
import style0 from "./Research.vue?vue&type=style&index=0&id=37c0daa1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c0daa1",
  null
  
)

export default component.exports